// extracted by mini-css-extract-plugin
export default {"container":"footer_container__tTpaG","grid":"footer_grid__T8FVW","startup":"footer_startup__szklD","logos":"footer_logos__GBYBJ","logo":"footer_logo__IRoNB"};